import { useEffect, useRef, useState } from "react";
import document from '../../favicon/document.png';

const delay = 2500;

const CustomSlider = ({ data }) => {

    const [index, setIndex] = useState(0);
    const timeoutRef = useRef(null);

    function resetTimeout() {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
    }

    useEffect(() => {
        resetTimeout();
        timeoutRef.current = setTimeout(
            () =>
                setIndex((prevIndex) =>
                    prevIndex === data?.length - 1 ? 0 : prevIndex + 1
                ),
            delay
        );

        return () => {
            resetTimeout();
        };
    }, [index]);


    const showCardImdPost = (item) => {

        const vidArr = ["mp4", "mp4", "mov", "wmv", "avi", "avchd", "flv", "f4v", "swf", "mkv", "webm", "html5"];
        const imgArr = ["jpg", "jpeg", "jfif", "pjpeg", "pjp", "png", "svg", "webp", "avif", "gif", "apng"];


        let ext = item?.split('.').pop();

        let fext = ext.toLowerCase();

        const im = imgArr?.find((v) => v == fext);
        const vid = vidArr?.find((vi) => vi == fext);

        if (vid != undefined) {

            return (
                <a href={item} target="_blank" >
                    <video controls className='sm:w-[329.787px] sm:h-[188px] inline-block rounded-2xl p-2 cursor-pointer hover:scale-105 ease-in-out duration-300'
                        src={item} alt="video not found" />
                </a>

            )
        } if (im != undefined) {
            return (
                <a href={item} target="_blank"  >
                <img
                    className='sm:w-[329.787px] sm:h-[188px]  rounded-2xl inline-block p-2 cursor-pointer hover:scale-105 ease-in-out duration-300'
                    src={item}
                    alt='/'
                />
                  </a>
            )
        }
        else {
            return (

                <a href={item} target="_blank" >
                <img className="rounded-2xl w-[220px] sm:h-[120px] " src={document} alt="img not found" />
                </a>
            )
        }


    }


    return (
        <div className="slideshow ">
            <div
                className="slideshowSlider rounded-lg "
                style={{ transform: `translate3d(${-index * 100}%, 0, 0)` }}
            >
                {data?.map((item, index) => (
                    <div className="slide" key={index} >
                        {showCardImdPost(item)}
                    </div>
                ))}
            </div>

            <div className="slideshowDots ">
                {data?.map((_, idx) => (
                    <div
                        key={idx}
                        className={`slideshowDot${index === idx ? " active" : ""}`}
                        onClick={() => {
                            setIndex(idx);
                        }}
                    ></div>
                ))}
            </div>
        </div>
    );
}

export default CustomSlider;
